import { asyncAction } from 'lib/actions';

export const fetchSignaturesAction = asyncAction('signatures/FETCH');
